<template>
  <div>
    <slot :loading="loading" :error="fmtError" :showPicker="showPicker"></slot>
  </div>
</template>

<script>

export default {
  props: {
    authenticated: Boolean,
    folderId: String,
    credentials: Object,
  },
  data() {
    return {
      ready: false,
      error: undefined,
      loading: false,
    }
  },
  computed: {
    fmtError() {
      if (!this.error) {
        return "";
      }
      const result = this.error.result;
      if (result && result.error) {
        return `${result.error.message} (${result.error.code})`;
      }
      else if (this.error.message) {
        return this.error.message;
      }
      else {
        console.error(this.error);
        return "Unknown error";
      }
    }
  },
  methods: {
    // async refresh() {
    //   try {
    //     this.loading = true;
    //     if (!this.ready) {
    //       return;
    //     }

    //     const id = await this.getFolderId();
    //     this.files = await this.listFiles(id);
    //   }
    //   catch (err) {
    //     this.error = err;
    //   }
    //   finally {
    //     this.loading = false;
    //   }
    // },
    // async getFolderId() {
    //   if (this.folderId) {
    //     return this.folderId;
    //   }
    //   this.folderId = this.getFolderIdByName(await this.getParentFolderId(), this.folderName);
    //   return this.folderId;
    // },
    // async getParentFolderId() {
    //   if (this.parentFolderId) {
    //     return this.parentFolderId;
    //   }
    //   const response = await window.gapi.client.drive.files.list({
    //     pageSize: 2,
    //     fields: 'files(id)',
    //     corpora: 'drive',
    //     supportsAllDrives: true,
    //     includeItemsFromAllDrives: true,
    //     driveId: this.driveId,
    //     q: `name = '${this.parentFolderName}' and mimeType = 'application/vnd.google-apps.folder' and trashed=false`
    //   });
    //   const folders = response.result.files;
    //   if (folders.length == 0) {
    //     throw new Error("Unable to find Drive parent folder");
    //   }
    //   this.parentFolderId = folders[0].id;
    //   return this.parentFolderId;
    // },
    // async listFiles(folderId) {
    //   const response = await window.gapi.client.drive.files.list({
    //     // TODO: Pagination
    //     pageSize: 10,
    //     fields: 'files(id, name, thumbnailLink)',
    //     corpora: 'drive',
    //     supportsAllDrives: true,
    //     includeItemsFromAllDrives: true,
    //     driveId: this.driveId,
    //     q: `'${folderId}' in parents and trashed=false`
    //   });
    //   return response.result.files;
    // },
    // async getFolderIdByName(parent, name) {
    //   const response = await window.gapi.client.drive.files.list({
    //     pageSize: 2,
    //     fields: 'files(id)',
    //     corpora: 'drive',
    //     supportsAllDrives: true,
    //     includeItemsFromAllDrives: true,
    //     driveId: this.driveId,
    //     q: `'${parent}' in parents and name = '${name}' and mimeType = 'application/vnd.google-apps.folder' and trashed=false`
    //   });
    //   const folders = response.result.files;
    //   if (folders.length >= 1) {
    //     if (folders.length > 1) {
    //       console.warn(`Multiple Drive folders exist with name ${name}. Using the first.`)
    //     }
    //     return folders[0].id;
    //   }
    //   else {
    //     return await this.createFolder(parent, name)
    //   }
    // },
    // async createFolder(parent, name) {
    //   const response = await window.gapi.client.drive.files.create({
    //     name: name,
    //     mimeType: 'application/vnd.google-apps.folder',
    //     supportsAllDrives: true,
    //     driveId: this.driveId,
    //     parents: [parent],
    //   });
    //   return response.result.id
    // },
    async showPicker(token, docType) {
      try {
        // const id = await this.getFolderId();
        const uploadView = new window.google.picker.DocsUploadView();
        uploadView.setParent(this.folderId);
        const picker = new window.google.picker.PickerBuilder()
          .addView(uploadView)
          .setOAuthToken(token)
          .setDeveloperKey(this.credentials.developerKey)
          .setCallback((resp) => {
            if (resp && resp.action == "picked" && resp.docs) {
              resp.docs.forEach((file) => this.$emit('fileLoad', file, docType))
            }
          })
          .setAppId(this.credentials.appId)
          .build();
        picker.setVisible(true);
      }
      catch (err) {
        this.error = err;
      }
    }
  },
  watch: {
    authenticated(authenticated) {
      if (authenticated) {
        // this.refresh();
      }
    },
    files() {
      this.$emit('fileLoad', this.files);
    }
  },
  mounted() {
    if (! this.folderId) {
      this.error = new Error("Unexpected error: Missing Google Drive upload folder.")
    }

    let script = document.createElement('script');
    script.setAttribute('src', 'https://apis.google.com/js/api.js');
    script.onload = () => {
      window.gapi.load('client', async function () {
        await window.gapi.client.init({
          discoveryDocs: ['https://www.googleapis.com/discovery/v1/apis/drive/v3/rest'],
        });
      });
      window.gapi.load('picker', function () { });
      this.ready = true;
    };
    document.head.appendChild(script)
  }
}
</script>
